import React from 'react';
export function SolutionSection() {
  return <section className="py-8 md:py-12 bg-gray-50 rounded-xl mt-2 mb-8 md:my-12" data-id="element-164">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-8" data-id="element-165">
        The All-In-One Solution
      </h2>
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-166">
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-167">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h2FFai4PeeV9DDR3iCQQfr/Untitled_design_%2861%29.png" alt="Vascura Cayenne Pepper liquid drops supplement bottle with heart background and ingredients" className="w-4/5 md:w-3/4 h-auto rounded-lg shadow-lg" data-id="element-168" />
        </div>
        <div className="w-full md:w-1/2 mt-4 md:mt-0" data-id="element-169">
          <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4" data-id="element-170">
            Robert Found Everything Combined in One Formula
          </h3>
          <p className="text-base md:text-lg mb-4 md:mb-6" data-id="element-171">
            Instead of taking 5 separate supplements, Robert discovered Vascura
            Cayenne Drops - the complete formula with:
          </p>
          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-172">
            <li className="flex items-center" data-id="element-173">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-174">🌶️</span>
              <span className="text-sm md:text-base" data-id="element-175">
                <strong data-id="element-176">Cayenne Pepper</strong> - Instant warming catalyst
              </span>
            </li>
            <li className="flex items-center" data-id="element-177">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-178">🟣</span>
              <span className="text-sm md:text-base" data-id="element-179">
                <strong data-id="element-180">Beetroot Extract</strong> - Natural nitric oxide booster
              </span>
            </li>
            <li className="flex items-center" data-id="element-181">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-182">🍇</span>
              <span className="text-sm md:text-base" data-id="element-183">
                <strong data-id="element-184">Hawthorn Berry</strong> - European heart herb
              </span>
            </li>
            <li className="flex items-center" data-id="element-185">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-186">🟡</span>
              <span className="text-sm md:text-base" data-id="element-187">
                <strong data-id="element-188">Turmeric</strong> - Anti-inflammatory powerhouse
              </span>
            </li>
            <li className="flex items-center" data-id="element-189">
              <span className="text-xl md:text-2xl mr-2 md:mr-3" data-id="element-190">☀️</span>
              <span className="text-sm md:text-base" data-id="element-191">
                <strong data-id="element-192">Vitamin D3 + K2</strong> - Arterial health duo
              </span>
            </li>
          </ul>
          <blockquote className="italic border-l-4 border-red-500 pl-3 md:pl-4 py-1 md:py-2 text-sm md:text-base text-gray-700 mb-6" data-id="element-193">
            "It was like my old buddy was still looking out for me." — Robert
          </blockquote>
        </div>
      </div>
      <div className="text-center mt-8" data-id="element-194">
        <a href="https://tryvascura.com/products/cayenne-pepper-supplement-liquid-drops" className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full text-lg shadow-lg transition duration-300 ease-in-out transform hover:scale-105" data-id="element-195">
          Get Your Vascura Drops Today
        </a>
        <p className="text-sm text-gray-600 mt-3" data-id="element-196">
          USDA Certified Organic • 5-in-1 Formula • 90-Day Guarantee
        </p>
      </div>
    </section>;
}